var IS_PRODUCTION = process.env.NODE_ENV === 'production';
export { IS_PRODUCTION };


//////////////////
// WEBPACK FOOTER
// ./node_modules/xstate/es/environment.js
// module id = 388
// module chunks = 0